import { ChangeDetectorRef, Directive, Input, NgModule, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

export class NgSubscribeContext {
  public ngSubscribe: any = null;
}

@Directive({
  /* tslint:disable */
  selector: '[ngSubscribe]'
  /* tslint:enable */
})
export class NgSubscribeDirective implements OnDestroy {
  // This directive is copied from here where you can find an explanation about what it does. HINT, its basically *ngIf but always creates the child view regardless.
  // https://netbasal.com/diy-subscription-handling-directive-in-angular-c8f6e762697f
  private observable: Observable<any>;
  private context: NgSubscribeContext = new NgSubscribeContext();
  private subscription: Subscription;

  @Input() set ngSubscribe(inputObservable: Observable<any>) {
    if (this.observable !== inputObservable) {
      this.observable = inputObservable;
      this.subscription && this.subscription.unsubscribe();
      this.subscription = this.observable.subscribe(value => {
        this.context.ngSubscribe = value;
        this.cdr.markForCheck();
      });
    }
  }

  constructor(
    private viewContainer: ViewContainerRef,
    private cdr: ChangeDetectorRef,
    private templateRef: TemplateRef<any>
  ) {
    this.viewContainer.createEmbeddedView(this.templateRef, this.context);
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }
}
@NgModule({
  declarations: [NgSubscribeDirective],
  exports: [NgSubscribeDirective],
})
export class NgSubscribeModule { }
